"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasAction = void 0;
var react_1 = __importDefault(require("react"));
var CardLink_1 = __importDefault(require("./CardLink"));
var hasAction = function (childrenToTest) {
    if (typeof childrenToTest === 'string') {
        return false;
    }
    var children = react_1.default.Children.toArray(childrenToTest);
    return children.filter(function (element) {
        return element && element.type && element.type === CardLink_1.default;
    }).length > 0;
};
exports.hasAction = hasAction;
